import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getQueryParamIgnoreCase } from '../../utilFuncs/utilFuncs';

type SortingOption = 'relevance' | 'early' | 'asc' | 'desc' | 'best-saving';

export interface SortingFilterByState {
  selectedSortingOptionFilterBy: SortingOption;
  isOpen: boolean;
}

function getParamsFromUrl(): SortingOption {
  const filterBy = getQueryParamIgnoreCase(window.location.search, 'filterBy');

  if (
    !filterBy ||
    (filterBy !== 'relevance' &&
      filterBy !== 'early' &&
      filterBy !== 'asc' &&
      filterBy !== 'desc' &&
      filterBy !== 'best-saving')
  ) {
    return 'relevance';
  }

  return filterBy;
}

const initialState: SortingFilterByState = {
  selectedSortingOptionFilterBy: getParamsFromUrl(),
  isOpen: false,
};

const sortingFilterBySlice = createSlice({
  name: 'sortingFilterBy',
  initialState,
  reducers: {
    setSelectedSortingOptionFilterBy: (state, action: PayloadAction<SortingOption>) => {
      state.selectedSortingOptionFilterBy = action.payload;
    },
    toggleDropdownFilterBy: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { setSelectedSortingOptionFilterBy, toggleDropdownFilterBy } =
  sortingFilterBySlice.actions;
export default sortingFilterBySlice.reducer;
